import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuTrash2 } from "react-icons/lu";
import AppModal from "../common/modal/AppModal";

// Avatar Anlatımı → Aidea Avatar Kütüphanesi kartındaki çöp kutusu için onay
// penceresi. Onaylanınca kayıtlı (org'a ait) avatar backend'den silinir; busy
// iken kapatma/çift tıklama engellenir. title/description verilirse başka bir
// kayıt (ör. AI Ses → klonlanmış ses) için de aynı pencere kullanılır.
const DeleteAvatarConfirmModal = ({
  show,
  onClose,
  onConfirm,
  avatarName,
  busy,
  title,
  description,
}) => {
  const noop = () => {};
  const name = avatarName || "";

  return (
    <AppModal
      show={show}
      onClose={busy ? noop : onClose}
      size="md"
      maxWidth={460}
      centered
      closeButton={!busy}
      showSceneToggle={false}
      backdrop="static"
      className="narrate-scope-modal"
      title={title || i18n.t("AvatarDelete.Title") || "Avatarı sil"}
      footer={
        <div className="app-modal__footer">
          <button
            type="button"
            className="app-modal__btn app-modal__btn--ghost"
            onClick={busy ? noop : onClose}
            disabled={busy}
          >
            {i18n.t("AvatarDelete.Cancel") || "Vazgeç"}
          </button>
          <button
            type="button"
            className="app-modal__btn app-modal__btn--danger"
            onClick={busy ? noop : onConfirm}
            disabled={busy}
          >
            {busy ? (
              <span className="add-sound-modal__scope-spinner" aria-hidden="true" />
            ) : (
              <LuTrash2 size={16} style={{ marginRight: 6 }} />
            )}
            {busy
              ? i18n.t("AvatarDelete.Deleting") || "Siliniyor..."
              : i18n.t("AvatarDelete.Confirm") || "Evet, sil"}
          </button>
        </div>
      }
    >
      <div className="add-sound-modal add-sound-modal__scope">
        <p className="add-sound-modal__scope-desc">
          {description ||
            i18n.t("AvatarDelete.Desc", { name, interpolation: { escapeValue: false } }) ||
            `Emin misiniz? Kayıtlı avatarınız „${name}“ tamamen silinecek ve bu avatar için oluşturulan tüm kayıtlar kaldırılacak. Bu işlem geri alınamaz. Sahnelere daha önce eklenmiş videolar etkilenmez.`}
        </p>
      </div>
    </AppModal>
  );
};

DeleteAvatarConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  avatarName: PropTypes.string,
  busy: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default DeleteAvatarConfirmModal;
